// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductAllergens-module--title--1s3El","allergen":"ProductAllergens-module--allergen--1kDwb","icon":"ProductAllergens-module--icon--1gABP"};